module.exports = "/images/759134168352eb2316b7898873c30b77.svg";